export default {"src":"/_next/static/media/why-lux.e92bd8f6.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};